import {Component, computed, EventEmitter, Input, OnInit, Output, signal, TemplateRef, ViewChild} from '@angular/core';
import {ProyectoItem, ProyectoResponse} from '../../../interfaces/proyecto.interface';
import {Router} from '@angular/router';
import {ProyectoService} from '../../services/proyecto.service';
import {Table} from 'primeng/table';
import {ConfirmationService, MessageService} from 'primeng/api';
import {DatePipe} from '@angular/common';
import {RandomSessionIdService} from "../../../../guards/random-session-id.service";
import {LoginServices} from "../../../../auth/login/services/login.service";
import {Param} from "../../../../shared/interfaces/param-interface";
import {InputSwitchChangeEvent} from "primeng/inputswitch";
import {
    ApiResponse_Error,
    ObtencionGenerica,
    TramiteEstadoEnum
} from '../ver-proyecto/interface/ver-proyecto.interface';
import Swal from 'sweetalert2';
import { SolicitudCancelarService } from '../../services/solicitud-cancelar.service';
import { SolicitudCancelarRequest } from '../../interfaces/solicitud-cancelar.interface';

@Component({
    selector: 'lista-proyectos',
    templateUrl: './lista-proyectos.component.html',
    styleUrls: ['./lista-proyectos.component.css'],
    providers: [ConfirmationService, MessageService, DatePipe, SolicitudCancelarService]
})
export class ListaProyectosComponent implements OnInit {



    /*===========================================================================================*/
    /*INPUTS & OUTPUTS --------------------------------------------------------------------------*/
    /*===========================================================================================*/



    //INPUTS --------------------------------------------------------------------------------------



    @Input() ocultarBotonNuevo: boolean = true;
    @Input() mostrarFiltros: boolean = true;
    @Input() titulo: string = "Inmuebles"
    @Input() cardStyle: string | null | undefined = ""
    @Input() skipOnInit: boolean = false;
    @Input() proyectos: ProyectoItem[] = []
    @Input() confirmarAsignacionTemplate!: TemplateRef<any>;
    @Input() confirmarEditAsignacionTemplate!: TemplateRef<any>;
    @Input() initEvaluacion!: TemplateRef<any>;



    //OUTPUTS --------------------------------------------------------------------------------------



    @Output() itemClickedEvaluacion = new EventEmitter<{ item: any, event: Event }>();



    /*===========================================================================================*/
    /*VARIABLES ---------------------------------------------------------------------------------*/
    /*===========================================================================================*/



    sessionId: string | null
    rangoDeFechas: Date[] | undefined;
    consoleEnabled: boolean = false;
    carnetCargado: boolean = false;
    carnetDescargado: boolean = false;
    carnetExistente: boolean = false;
    carnetData: ObtencionGenerica = {};
    estadoValidoParaDescarga: string = "Aprobada";
    minCaracteres: number = 10;
    openObservaciones = signal(false);
    openConfirmacionCancelacion = signal(false);
    proyectoSeleccionado: ProyectoItem[] = [];
    selectedCount = computed(() => this.selectedProyectos().length);
    selectedProyectos = signal<ProyectoItem[]>([]);
    observaciones = signal('');
    isLoading = signal(false);


    constructor(
        private confirmationService: ConfirmationService,
        private messageService: MessageService,
        public rs: RandomSessionIdService,
        public loginServices: LoginServices,
        private router: Router,
        private proyectoServices: ProyectoService,
        private datePipe: DatePipe,
        private solicitudCancelarService: SolicitudCancelarService
    ) {
        this.sessionId = rs.randomSessionId();
    }

    ngOnInit() {
        console.log(`ngOnInit() ->` + this.constructor.name)
        if (!this.skipOnInit) {
            this.consultarGeneralesProyecto();
        }
    }

    @ViewChild('calendar') private calendar: any;


    observacionesTexto(texto: string) {
        this.observaciones.set(texto);
    }

    isAtencionCliente = computed(() => this.loginServices.hasRole('atencion.cliente'));
    //validacion para limpiar el editor con los tags html para validacion de caracteres
    observacionInvalida = computed(() => this.observaciones().trim().length < this.minCaracteres)

    //nueva validacion
    // observacionInvalida = computed(() => {
    //     const textoPlano = this.stripHtmlTags(this.observaciones()).trim();
    //     return textoPlano.length < this.minCaracteres;
    // });

    confirmarCancelacion() {
        if(this.isLoading())return;
        console.log('Observación:', this.observaciones);
        console.log('Seleccionados:', this.selectedProyectos());
        const seleccionados = this.selectedProyectos();
        const observacion = this.observaciones();

        if(this.observacionInvalida())return;

        const usuario = this.loginServices.session()?.perfil?.usuario;
        const uniqueId = this.loginServices.session()?.perfil?.uniqueId;

        const payload: SolicitudCancelarRequest[] = seleccionados.map(proyecto => ({
            idProyecto: proyecto.idProyecto,
            idSolicitud: proyecto.idSolicitud,
            creadoPor: usuario,
            observaciones: observacion,
            estado: true,
            unique_id_usuario: uniqueId
        }));
        this.isLoading.set(true);
        this.solicitudCancelarService.cancelarSolicitud(payload).subscribe({
            next: (resp) => {
                console.log('Respuesta -----> ', resp);
                Swal.fire({
                    icon: 'success',
                    title: 'Solicitud Cancelada',
                    text: 'Solicitud/es cancelada/s',
                    confirmButtonAriaLabel: 'Aceptar'
                })
                this.isLoading.set(false);
            },
            error: (err) => {
                console.log(err.error.mensaje);
                this.isLoading.set(false);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: err.error.mensaje,
                    confirmButtonAriaLabel: 'Aceptar'
                })
            },
            complete: () => {
                this.selectedProyectos.set([]);
                this.observaciones.set('');
                this.openObservaciones.set(false);
                this.isLoading.set(false);
                this.consultarGeneralesProyecto();
            }
        })
        console.log('Payload --------> ', payload);
        this.observaciones.set('');
        this.selectedProyectos.set([]);
        this.openObservaciones.set(false);
    }

    puedeCancelar(): boolean {
        const seleccionados = this.selectedProyectos();
        if (!seleccionados || seleccionados.length === 0) return false;
        return seleccionados.every(p => p.estadoSolicitud?.toLowerCase() === 'pendiente');
    }
    //evaluar si se puede
    esSeleccionable(proyecto: ProyectoItem): boolean {
        const estado = proyecto.estadoSolicitud?.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        return estado === 'pendiente';
    }

    esCancelada(proyecto: ProyectoItem): boolean{
        return proyecto.estadoSolicitud.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') === 'cancelacion';
    }
    obtenerNombreEstado(estado: string | undefined): string {
        if (!estado) return '';

        const normalizado = estado.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        return normalizado === 'cancelacion' ? 'Cancelada' : estado;
    }
    ejecutarCancelacion() {
        this.openConfirmacionCancelacion.set(false);
        this.confirmarCancelacion();
    }
    hiddeDialog() {
        this.openObservaciones.set(false);
    }

    toggleSeleccionarTodos(seleccionar: boolean) {
        const seleccionables = this.proyectos.filter(p => this.esSeleccionable(p));
        this.selectedProyectos.set(seleccionar ? seleccionables : []);
    }

    todosSeleccionados(): boolean {
        const seleccionables = this.proyectos.filter(prj => !this.esCancelada(prj));
        const seleccionados = this.selectedProyectos();
        return seleccionables.every(sel => seleccionados.includes(sel)) && seleccionados.length === seleccionables.length;
    }

    mensajeWarning(title?: string, mensaje?: string): void {
        Swal.fire({
            title: title ? title : "Lo lamentamos",
            text: mensaje ? mensaje : "Su carnet no fue posible generarse",
            icon: "warning"
        });
    }

    mensajeSuccess(title?: string, mensaje?: string): void {
        Swal.fire({
            title: title ? title : "Resolucion exitosa",
            text: mensaje ? mensaje : "Su carnet no fue posible generarse",
            icon: "success"
        });
    }

    estadoSolicitudAprovado(proyecto: ProyectoItem): boolean {
        return proyecto.estadoSolicitud.toLowerCase() === this.estadoValidoParaDescarga.toLowerCase()
    }

    isRegistroProfesional(proyecto: ProyectoItem): boolean {
        return proyecto.nombre.startsWith('RP_') || false;
    }

    isRolCliente = computed(() =>{
        return this.loginServices.hasRoles(['cliente_ventanilla'])
    });
    isRolFuncionario = computed(() =>{
        return this.loginServices.hasRoles(['ministro','gerente','jefe','tecnico_resolutor', 'atencion.cliente'])
    });

    consultaPorFechas() {
        console.log(`this.rangoDeFechas:${this.rangoDeFechas}`);
        if (this.rangoDeFechas != null && this.rangoDeFechas[0] != null && this.rangoDeFechas[1] != null) {
            let desde = this.datePipe.transform(this.rangoDeFechas[0], "dd/MM/yyyy");
            let hasta = this.datePipe.transform(this.rangoDeFechas[1], "dd/MM/yyyy");
            this.calendar.overlayVisible = false;
            let params: Param[] = [];
            params.push({key: "usuarios", value: this.loginServices.session()?.perfil.usuario});
            params.push({key: "desde", value: desde});
            params.push({key: "hasta", value: hasta});
            // params.push( {key: "estados_solicitud", value: "1,2,3,4,5,6,7,8,9,10,11"});
            this.proyectoServices.consultarPorParametros(params)
                .subscribe({
                    next: (result) => {
                        this.proyectos = result.body!
                    },
                    error: (error) => {
                        this.proyectos = [];
                        console.log(error)
                        this.messageService.add({severity: 'warn', summary: 'No se encontraron resultados'});
                    }
                });
        }
    }

    @Output() itemClicked = new EventEmitter<{ item: any, event: Event, operationType: number }>();
    @Input()
    hideNoTramites: boolean = false;

    onItemClicked(item: ProyectoResponse, operationType: number, event: Event) {
        this.itemClicked.emit({item, event, operationType});
    }
    onItemClickedEvaluacion(item: ProyectoResponse,  event: Event) {
        this.itemClickedEvaluacion.emit({item, event});
    }

    consultarGeneralesProyecto() {
        this.proyectoServices.getGeneralesProyecto(this.loginServices.session()?.perfil.usuario)
            .subscribe({
                next: (result) => {
                    this.proyectos = result.body!
                },
                error: (error) => {
                    console.log(error)
                }
            });
    }

    onChange(event: InputSwitchChangeEvent) {
        console.log(`this.event:${JSON.stringify(event)}`);
        if (event.checked) {
            if (this.proyectos != null && this.proyectos.length > 0) {
                let items = this.proyectos;
                this.proyectos = items.filter(t => t.cantidadTramites > 0);
            }
        } else {
            this.consultarGeneralesProyecto();
        }
    }

    clear(table: Table) {
        table.clear();
        this.proyectos = [];
        this.rangoDeFechas = [];
    }
}
